import axios from 'axios';

const api = axios.create({
  // Same-origin in production (backend serves the frontend); localhost in dev
  baseURL: process.env.REACT_APP_API_URL
    || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3001')
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('cw_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('cw_token');
      localStorage.removeItem('cw_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
